import { render, staticRenderFns } from "./myAppCate.vue?vue&type=template&id=24acc31d&scoped=true&"
import script from "./myAppCate.vue?vue&type=script&lang=js&"
export * from "./myAppCate.vue?vue&type=script&lang=js&"
import style0 from "./myAppCate.vue?vue&type=style&index=0&id=24acc31d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24acc31d",
  null
  
)

export default component.exports